import { css } from '@emotion/css';
import { DesignToken } from '@livechat/design-system-react-components';

export const customSegmentsStepStyles = css`
  background-color: var(${DesignToken.SurfacePrimaryDefault});
`;
